import { render, staticRenderFns } from "./GeneralMessageComponent.vue?vue&type=template&id=1baedf03&scoped=true"
import script from "./GeneralMessageComponent.vue?vue&type=script&lang=js"
export * from "./GeneralMessageComponent.vue?vue&type=script&lang=js"
import style0 from "./GeneralMessageComponent.vue?vue&type=style&index=0&id=1baedf03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baedf03",
  null
  
)

export default component.exports